import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e1e6b0e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navbar-bg-hover"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "dark:text-black"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
import store from '@/store';
import { useRenderIcon } from '@/hooks/useIcons';
import { reactive, ref } from 'vue';
import { editPass, getLogout, IEditPassImpl } from '@/apis/user';
import { ElMessage } from 'element-plus';
import { Lock, SwitchButton } from '@element-plus/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  setup(__props) {
    const avator = store.state.app.userPeofile.avator;
    const username = store.state.app.userPeofile.username;
    const editPassVisible = ref(false);
    const ruleFormRef = ref(null);
    const loading = ref(false);
    const formData = ref({
      oldPass: '',
      newPass: '',
      confirmPassword: ''
    });
    // 修改密码模态框显示
    const editPassShow = () => {
      editPassVisible.value = true;
    };
    // 修改密码
    const handleEditPass = formRef => {
      loading.value = true;
      if (!formRef) return;
      formRef.validate(async (valid, fields) => {
        if (valid) {
          // const res: any = await editPass({
          //   oldPass: formData.value.oldPass,
          //   newPass: formData.value.newPass
          // })
          const res = await editPass(new IEditPassImpl(formData.value.newPass, formData.value.oldPass));
          if (res.code === 200) {
            logout();
          } else {
            loading.value = false;
            ElMessage({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          loading.value = false;
          return fields;
        }
      });
    };
    // 退出登录
    const logout = async () => {
      await getLogout();
      store.dispatch('app/logout');
      ElMessage({
        message: '操作成功',
        type: 'success'
      });
    };
    /* 修改密码校验 */
    const editPassRules = reactive({
      oldPass: [{
        validator: (rule, value, callback) => {
          let oldPass = value?.trim();
          if (oldPass === '') {
            callback(new Error('旧密码不能为空'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      newPass: [{
        validator: (rule, value, callback) => {
          const newPass = value?.trim();
          if (newPass === '') {
            callback(new Error('新密码不能为空'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      confirmPassword: [{
        validator: (rule, value, callback) => {
          const confirmPass = value?.trim();
          const newPass = formData.value.newPass.trim();
          if (confirmPass === '') {
            callback(new Error('确认密码不能为空'));
          } else if (confirmPass !== newPass) {
            callback('与新密码不一致');
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }]
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dropdown, {
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "logout"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: editPassShow
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Lock))]),
              _: 1
            }), _createTextVNode(" 修改密码 ")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
              _: 1
            }), _createTextVNode(" 退出登录 ")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createElementVNode("img", {
          src: _unref(avator)
        }, null, 8, _hoisted_2), _unref(username) ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(username)), 1)) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: editPassVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => editPassVisible.value = $event),
        title: "修改密码"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: formData.value,
          class: "forget-pass-form",
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          rules: editPassRules,
          size: "large"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "oldPass"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.oldPass,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.oldPass = $event),
              placeholder: "旧密码",
              type: "password",
              "prefix-icon": _unref(useRenderIcon)('password', {
                size: 12
              }),
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue", "prefix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "newPass"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.newPass,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.newPass = $event),
              placeholder: "新密码",
              type: "password",
              "prefix-icon": _unref(useRenderIcon)('password', {
                size: 12
              }),
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue", "prefix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "confirmPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.confirmPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.confirmPassword = $event),
              placeholder: "确认密码",
              type: "password",
              "prefix-icon": _unref(useRenderIcon)('password', {
                size: 12
              }),
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue", "prefix-icon"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => editPassVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "bg-blue",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleEditPass(ruleFormRef.value)),
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 修改 ")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});